import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import type { StackProps } from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import customFieldsEmpty from './custom-fields-empty.png';
import { supportUrls } from 'utils/urls';

const EMPTY_STATE_IMAGE_DIMENSIONS = {
  width: 688,
  height: 360,
  maxWidth: 200,
};

type CustomFieldsLayoutEmptyProps = {
  title: string;
  subtitle: string;
  includeSupportLink?: boolean;
  sx?: StackProps['sx'];
};

export const CustomFieldsEmptyState = ({ title, subtitle, includeSupportLink = false, sx }: CustomFieldsLayoutEmptyProps) => {
  const { t } = useTranslation();
  return (
    <Stack role="status" gap={2} alignItems="center" justifyContent="center" overflow="hidden" sx={sx}>
      <img
        src={customFieldsEmpty}
        alt=""
        role="presentation"
        width={EMPTY_STATE_IMAGE_DIMENSIONS.maxWidth}
        height={(EMPTY_STATE_IMAGE_DIMENSIONS.maxWidth * EMPTY_STATE_IMAGE_DIMENSIONS.height) / EMPTY_STATE_IMAGE_DIMENSIONS.width}
      />
      <Typography variant="h6" component="h2" fontWeight={600} color="text.primary">
        {title}
      </Typography>
      <Typography color="text.secondary" textAlign="center" maxWidth={400}>
        {subtitle}
      </Typography>
      {includeSupportLink ? (
        <Button
          component="a"
          href={supportUrls.get(supportUrls.customFields)}
          target="_blank"
          rel="noopener noreferrer"
          variant="outlined"
          color="info"
          sx={{ mt: 1 }}
        >
          {t('settings.legacy.custom_fields.learn_more')}
        </Button>
      ) : null}
    </Stack>
  );
};
